import React from 'react';
import propTypes from 'prop-types';
import { FormFeedback, Input, Label } from 'reactstrap';

import { makeId } from 'utils/selectors';

import HelpIcon from './HelpIcon';
import styles from './CheckBoxList.css';

/**
 * render an array of values as an inline checkbox group
 * @param {object} props - props passed to the component
 * @returns {React.Component} - CheckBoxList canvas widget
 */
const CheckBoxList = ({
  fieldContract: { allowedValues = [], helpText, name, required },
  isReadonly,
  onChange,
  selectedValue,
  updateLocation,
  validationMessage
}) => {
  /**
   * update redux state prop value when checked/unchecked
   * @param {object} e - action event
   */
  const handleChange = e => {
    let selectedData = selectedValue || [];
    const val = e.target.value;
    if (e.target.checked && !selectedData.includes(val)) {
      selectedData.push(val);
    } else {
      selectedData = selectedData.filter(item => item !== val);
    }
    onChange(selectedData);
  };
  return (
    <div className="d-flex flex-column my-3" key={name}>
      <span className="d-flex align-items-center font-weight-bold mb-2">
        {`${name}${required ? '*' : ''}`}
        {helpText && <HelpIcon id={makeId({ updateLocation })} message={helpText} />}
      </span>
      {allowedValues.map(allowedValue => {
        const val = allowedValue.value || allowedValue;
        const isSelected = selectedValue.includes(val);
        return (
          <div className="d-flex" key={val}>
            <Label check>
              <Input
                invalid={validationMessage}
                disabled={isReadonly}
                type="checkbox"
                checked={isSelected}
                value={val}
                className={styles.checkboxMargin}
                onChange={e => handleChange(e)}
                data-test-id={makeId({ updateLocation, selectedValue: val })}
              />
              {allowedValue.displayName || allowedValue}
              <FormFeedback>{validationMessage}</FormFeedback>
            </Label>
          </div>
        );
      })}
    </div>
  );
};
CheckBoxList.propTypes = {
  fieldContract: propTypes.shape({
    allowedValues: propTypes.arrayOf(
      propTypes.oneOfType([propTypes.string, propTypes.object])
    ),
    helpText: propTypes.string,
    name: propTypes.string,
    required: propTypes.bool
  }).isRequired,
  isReadonly: propTypes.bool,
  onChange: propTypes.func.isRequired,
  selectedValue: propTypes.arrayOf(propTypes.string).isRequired,
  updateLocation: propTypes.string.isRequired,
  validationMessage: propTypes.string
};

CheckBoxList.defaultProps = {
  isReadonly: false,
  validationMessage: undefined
};

export default CheckBoxList;
